const browserList = {
    opera: 'Opera',
    chrome: 'Chrome',
    ie: 'IE',
    firefox: 'Firefox',
    safari: 'Safari',
    unknown: 'Known'
}

export default browserList;